import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';
import { FormattedNumber } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SmallPagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      onChange = _ref.onChange,
      disabled = _ref.disabled;

  var renderPageItems = function renderPageItems() {
    var pages = [];

    if (totalPages <= 7) {
      // Display all page buttons
      for (var i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (var _i = 1; _i <= 5; _i++) {
          pages.push(_i);
        }

        pages.push(-1);
        pages.push(totalPages);
      } else if (totalPages - currentPage <= 3) {
        pages.push(1);
        pages.push(-1);

        for (var _i2 = totalPages - 4; _i2 <= totalPages; _i2++) {
          pages.push(_i2);
        }
      } else {
        pages.push(1);
        pages.push(-1);

        for (var _i3 = -1; _i3 <= 1; _i3++) {
          pages.push(currentPage + _i3);
        }

        pages.push(-2);
        pages.push(totalPages);
      }
    }

    return pages.map(function (page) {
      return page > 0 ? /*#__PURE__*/_jsx(Pagination.Item, {
        active: page === currentPage,
        onClick: function onClick() {
          return page !== currentPage && onChange(page);
        },
        disabled: disabled,
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: page
        })
      }, page) : /*#__PURE__*/_jsx(Pagination.Ellipsis, {
        disabled: true
      }, page);
    });
  };

  var isFirst = currentPage <= 1,
      isLast = currentPage >= totalPages;
  return /*#__PURE__*/_jsxs(Pagination, {
    className: "justify-content-center",
    children: [/*#__PURE__*/_jsx(Pagination.Prev, {
      disabled: isFirst || disabled,
      onClick: function onClick() {
        return !isFirst && onChange(currentPage - 1);
      }
    }), renderPageItems(), /*#__PURE__*/_jsx(Pagination.Next, {
      disabled: isLast || disabled,
      onClick: function onClick() {
        return !isLast && onChange(currentPage + 1);
      }
    })]
  });
}
SmallPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};